import { DateTime } from "luxon";

export const MAX_REPORT_DAYS = 31;

export function toReportRange(startDate, endDate, zone) {
  if (!startDate || !endDate) return { error: "Please select a start and end date." };
  const from = DateTime.fromISO(startDate, { zone }).startOf("day");
  const to = DateTime.fromISO(endDate, { zone }).plus({ days: 1 }).startOf("day");
  if (!from.isValid || !to.isValid) return { error: "Please select a start and end date." };
  if (to <= from) return { error: "The end date must be on or after the start date." };
  if (to.diff(from, "days").days > MAX_REPORT_DAYS) {
    return { error: `Please select ${MAX_REPORT_DAYS} days or fewer.` };
  }
  return { from: from.toUTC().toISO(), to: to.toUTC().toISO() };
}
